import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { GetUserDetail } from '@modules/profile/actions/user-detail.actions';
import { select, Store } from '@ngrx/store';
import {
  DownloadDocument,
  UpdateMerchantDetail,
} from '@modules/profile/actions/merchant-detail.actions';
import * as userReducers from '@modules/profile/reducers';
import { UserDetailInterface } from '@interfaces/user-detail.interface';
import { isDefined } from '@angular/compiler/src/util';
import { Subscription } from 'rxjs';
// import { UserDetailService } from '@modules/profile/services/user-detail.service';
import { MessengerService } from '@modules/messenger/messenger.service';
import { isSetInput } from '@modules/login/services/utils';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as loginReducers from '@modules/login/reducers';
import { UserDetailService } from "@modules/profile/services/user-detail.service"
import { UpdateUserService } from '@modules/profile/services/update-user.service';

@Component({
  selector: 'edex-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.scss']
})
export class UserDetailComponent implements OnInit {

  private merchantDetailSub: Subscription;
  public offerFormGroup: FormGroup;
  
  public visibleAPIKEY = false;
  public visibleSecretKEY = false;
  public visibleStellerPublicKEY = false;
  public visibleStellerSecretKEY = false;
  public offerCode = false;

  public userDetail$ = this.store.pipe(select(userReducers.getUserDetailCollection));
  public userDetailInfo: any;
  public user$ = this.store.pipe(select(loginReducers.getUser));
  public user: any;
  public userType = '';

  @Input() userId: string;
  @Input() showUserInfo: boolean;

  constructor(
    private store: Store<userReducers.State>,
    private userApiService: UserDetailService,
    private msgr: MessengerService,
    private fb: FormBuilder,
    private userService: UpdateUserService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    this.matIconRegistry.addSvgIcon(
      "unicorn",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../../../../../../assets/img/icon.svg")
    );

  }

  ngOnInit() {
    this.store.dispatch(new GetUserDetail({ userId: this.userId }));
    console.log(this.userId)
    this.offerFormGroup = this.fb.group({
      offerCode: [''],
    });

    this.userApiService.getUserDetail(this.userId)
    .subscribe(
      (data) => {
        console.log(data, 'data')
        this.userDetailInfo = data;
        // this.msgr.message('API key is updated successfully.');
        // this.store.dispatch(new GetUserDetail({ userId: this.userId }));
      },
      (err) => {
        this.msgr.error(err.message);
      }
    );
    this.user$.subscribe((user) => {
      console.log(user)
      this.user = user;
    });
  }



  approveMerchant() {
    // this.merchantApiService.approveMerchant(this.userId).subscribe(
    //   (res) => {
    //     this.store.dispatch(new UpdateMerchantDetailSuccess(res));
    //     this.msgr.message('The merchant is approved successfully.');
    //   },
    //   (err) => {
    //     this.msgr.error(err.message || 'Failed to approve merchant.');
    //   }
    // );
  }
  saveMerchant() {
    this.store.dispatch(new UpdateMerchantDetail({
      userId: this.userId,
      merchantDetail: {
        ...this.offerFormGroup.value,
        sectionField: 'additionalInfoStatus'
      }
    }));
  }


  assessSection(field: string) {
    // if (this.user && (this.user.role === 'Admin' || this.user.role === 'SuperAdmin')) {
    //   if (this.merchantDetailInfo && this.merchantDetailInfo[field] === 'pending') {
    //     this.merchantApiService.assessingSection(this.userId, field)
    //       .subscribe(
    //         (res) => {
    //           this.store.dispatch(new UpdateMerchantDetailSuccess(res));
    //         },
    //         (err) => {
    //           this.msgr.error(err.message);
    //         }
    //       );
    //   }
    // }

  }

  showSecretKey() {
    this.visibleSecretKEY = true;
  }

  hideSecretKey() {
    this.visibleSecretKEY = false;
  }
  showStellerSecretKey() {
    this.visibleStellerSecretKEY = true;
  }

  hideStellerSecretKey() {
    this.visibleStellerSecretKEY = false;
  }
  showStellerPublicKey() {
    this.visibleStellerPublicKEY = true;
  }

  hideStellerPublicKey() {
    this.visibleStellerPublicKEY = false;
  }
  editOfferCode() {
    this.offerCode = true;
  }
  blockOfferCode() {
    this.offerCode = false;
  }

  showAPIKey() {
    this.visibleAPIKEY = true;
  }

  hideAPIKey() {
    this.visibleAPIKEY = false;
  }

  updateAPIKey() {
    this.userService.updateApiKey(this.userId)
      .subscribe(
        () => {
          this.msgr.message('API key is updated successfully.');
          this.store.dispatch(new GetUserDetail({ userId: this.userId }));
        },
        (err) => {
          this.msgr.error(err.message);
        }
      );
  }

  updateSecretKey() {
    this.userService.updateSecretKey(this.userId)
      .subscribe(
        () => {
          this.msgr.message('Secret key is updated successfully.');
          this.store.dispatch(new GetUserDetail({ userId: this.userId }));
        },
        (err) => {
          this.msgr.error(err.message);
        }
      );
  }

  ngOnDestroy() {
    if (this.merchantDetailSub) {
      this.merchantDetailSub.unsubscribe();
    }
  }
}
